import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export type CellMove = 'none' | 'right' | 'left' | 'down';

/** In-cell text editing: Tab / Shift+Tab / Enter commit and move on, blur commits, Escape cancels. */
export function CellEditor({ value, onCommit, onCancel }: { value: string; onCommit: (text: string, next: CellMove) => void; onCancel: () => void }) {
  const { t } = useTranslation();
  const done = useRef(false);
  const finish = (text: string, next: CellMove) => {
    if (done.current) return;
    done.current = true;
    onCommit(text, next);
  };
  return (
    <textarea
      autoFocus
      data-canvas-ignore
      aria-label={t('table.editCell')}
      defaultValue={value}
      onFocus={(e) => e.currentTarget.select()}
      onBlur={(e) => finish(e.currentTarget.value, 'none')}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === 'Escape') {
          done.current = true;
          onCancel();
        } else if (e.key === 'Tab') {
          e.preventDefault();
          finish(e.currentTarget.value, e.shiftKey ? 'left' : 'right');
        } else if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          finish(e.currentTarget.value, 'down');
        }
      }}
      className="absolute inset-0 z-10 resize-none border-2 border-accent bg-white px-2 py-2 font-sans text-sm text-[#141414] outline-none"
    />
  );
}
